module.exports = __webpack_public_path__ + "img/-LV4qEG0J0ZY_Hlo-jC-.843d2440.jpg";